import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PdfManagerService } from '../../___LOGIC/__pdf/pdf-manager.service';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';

@Component({
  selector: 'app-pdf-guide-page',
  templateUrl: './pdf-guide-page.component.html',
  styleUrls: ['./pdf-guide-page.component.css']
})
export class PdfGuidePageComponent implements OnInit {

  token;
  expired = false;
  maxDownloads = false;
  status;
  pdfInfo = {
    imageUrl: null,
    pdfUrl: null,
    pdfProduct: null,
    title: null
  };

  showGuideDetails =  false;

  constructor(private route: ActivatedRoute,private pdfManagerService: PdfManagerService,private router: Router,private configService: ConfigService) { }

  ngOnInit(): void {
    //Process URL
    if(this.route.snapshot.paramMap.get('token')){
      //this.mode = 'validateToken';
      this.token = this.route.snapshot.paramMap.get('token');
      //this.preRegistered = true;
      this.load();
      //this.signin.get('password').valueChanges.subscribe(value => this.onPasswordInput(value));
    }else{
      debugger
      this.pdfInfo.title = 'TITULO DE PDF TRAIDO DE PDF MANAGER';
      this.showGuideDetails = true;
    }
  }

  async load(){
    let url = this.configService.getApiUrlRefactor('appBase')+"pdf-guides/open_pdf_guide.php?token="+this.token;
    const data = await this.pdfManagerService.validatePdfGuideToken(url).toPromise();
    if(data['success']){
      this.pdfInfo.imageUrl = 'https://imagedelivery.net/_h1KjDl91qmiTNUGHVGxKQ/b3da8c49-0a7f-4f1a-ac08-bdfb63e62600/public';
      this.pdfInfo.pdfUrl = data['guide'].url;
      this.pdfInfo.pdfProduct = data['guide']['FK_ID_product'];
      this.status = data['guide']['paid'];
    }else{
      data && data['error']? console.log(data['error']) : console.log('Error on token validation');
      this.expired = true;
    }
  }

  downloadGuide(){
    this.pdfManagerService.downloadAnyPdf(this.pdfInfo.pdfUrl);
  }

  openPdf(){
    this.pdfManagerService.enableAccessToPdf();
    this.pdfManagerService.setCurrentPdfId(this.pdfInfo.pdfUrl);
    this.router.navigateByUrl('pdf-guide-view/'+this.pdfInfo.pdfProduct);
  }

  showDownloadButton(){
    return this.status == 'paid';
  }

}
